import { CompanyAccountEditPage } from "@/features/company/pages/CompanyAccountEdit";

const CompanyAccountEdit = () => {
  return <CompanyAccountEditPage />;
};

export default CompanyAccountEdit;
